'use client'

import { AnimatePresence, LazyMotion, m } from 'framer-motion'

import { useTopNav } from '@src/components/TopNavV3/TopNavContext'
import { TopNavMobileMenu } from '@src/components/TopNavV3/TopNavMobile/TopNavMobileMenu'
import { TopNavMobileSubMenu } from '@src/components/TopNavV3/TopNavMobile/TopNavMobileSubMenu'

const loadFramerMotionFeatures = async () =>
  await import('./framerMotionFeatures').then((res) => res.framerMotionFeatures)

export const TopNavMobileSlidingPanel = ({ navBox }: { navBox?: DOMRect | null }) => {
  const { isExpanded, isMobileSubExpanded } = useTopNav()
  const transition = {
    type: 'spring',
    duration: 0.3,
    bounce: 0,
  }
  const menuProps = {
    variants: {
      open: {
        x: '0',
      },
      closed: {
        x: '-100%',
      },
    },
    initial: 'closed',
    animate: isExpanded ? (isMobileSubExpanded ? 'closed' : 'open') : 'closed',
    exit: 'closed',
    transition,
  }
  const subMenuProps = {
    variants: {
      closedRight: {
        x: '100%',
      },
      closedLeft: {
        x: '-100%',
      },
      open: {
        x: '0',
      },
    },
    initial: 'closedRight',
    animate: isMobileSubExpanded ? (isExpanded ? 'open' : 'closedLeft') : 'closedRight',
    exit: isExpanded ? 'closedRight' : 'closedLeft',
    transition,
  }
  const asideClassNames =
    'absolute z-50 overflow-y-scroll left-0 w-full bg-bodi-black-text bg-gradient-to-t from-white/10 to-white/0 text-white'

  const style = !navBox
    ? undefined
    : {
        top: `${navBox.height}px`,
        height: `calc(100dvh - ${navBox.top}px - ${navBox.height}px)`,
      }

  return (
    <LazyMotion features={loadFramerMotionFeatures}>
      <AnimatePresence>
        {isExpanded && (
          <m.aside key="menu" className={asideClassNames} {...menuProps} style={style}>
            <TopNavMobileMenu />
          </m.aside>
        )}

        {isMobileSubExpanded && (
          <m.aside key="submenu" className={asideClassNames} {...subMenuProps} style={style}>
            <TopNavMobileSubMenu />
          </m.aside>
        )}
      </AnimatePresence>
    </LazyMotion>
  )
}
